import { PaneSize } from "./PaneSize";
import { PaneSizeContext } from "./PaneSizeContext";
import { useContext } from "react";

export const usePaneSize = (): PaneSize => {
  const size = useContext(PaneSizeContext);
  if (size === null)
    throw new Error("usePaneSize can only be used inside a PaneSizeProvider");
  return size;
};
